import { Box, darkScrollbar } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { ScrollCss } from 'styles/GlobalCss';
import { dark } from 'styles/theme';
import { thirdly5 } from 'styles/theme';
import { thirdly3 } from 'styles/theme';

export const NewsletterStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "auto",
    rowGap: 10,
    '.MuiSvgIcon-root': {
        fill: `${dark} !important`
    },
    '.newsletter-header': {
        display: "flex",
        justifyContent: "end",
        height: 30
    },
    '.news-date': {
        height: "1rem",
    },
    '.news-name': {
        height: "1rem",
    },
    '.newsletter-list': {
        display: "flex",
        columnGap: 12,
        rowGap: 12,
        flexWrap: "wrap",
        overflowY: "auto",
        flexGrow: 1,
        ...ScrollCss,
    },
    '.news-header': {
        color: thirdly5,
        display: "flex",
        justifyContent: "space-between",
    },
    '.news-description': {
        height: "2.1rem",
        fontSize: 15,
        display: "-webkit-box",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    '.news-card': {
        maxWidth: "15rem",
        minWidth: "15rem",
        height: "19rem",
        borderRadius: 15,
        border: `1px solid ${thirdly3}`,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        background: "white"
    },
    '.news-content': {
        color: dark,
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.news-title': {
        fontSize: "1.5rem",
        fontWeight: 700,
        height: "3rem",
        lineHeight: "24px"
    },
    '.news-image': {
        width: "100%",
        height: 150,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 20
    },
    '.news-footer': {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
}));

export const NewsletterActionStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    fontSize: 17,
    marginBottom: 15
}));

export const ViewNewsletterStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    flexGrow: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    color: dark,
    '.wrap-news-title': {
        display: "flex",
        justifyContent: "space-between",
        margin: "7px 0px"
    },
    '.news-header-action': {
        height: 30,
        display: "flex",
        justifyContent: "end",
        paddingBottom: 20
    },
    '.view-newsletter': {
        height: "100%",
        background: "white",
        borderRadius: 15,
        padding: 20,
        boxSizing: "border-box",
        flexGrow: 1,
        overflowY: "auto",
        ...ScrollCss
    },
    '.news-title': {
        margin: 0
    },
    '.news-description': {
        marginBottom: 20,
        height: "1rem",
    }
}));

export const CreateNewsletterStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "auto",
    '.create-newsletter': {
        paddingTop: 30,
        boxSizing: "border-box",
        width: "92%",
        overflowY: "auto",
        ...ScrollCss,
    },
    '.news-fileds': {
        display: "grid",
        gridGap: 12,
        padding: "4px 0px",
        overflowY: "auto",
        ...ScrollCss,
        gridTemplateAreas: `
        "area date"
        "name description"
        "image image"
        "editor editor" 
        `
    },
    '.news-submit-actions': {
        display: "flex",
        width: "100%",
        justifyContent: "end",
        columnGap: 10
    },
    '._editor': {
        gridArea: "editor",
        minHeight: 300
    },
    '._date': {
        gridArea: "date",
    },
    '._name': {
        gridArea: "name"
    },
    '._area': {
        gridArea: "area"
    },
    '._title': {
        gridArea: "title"
    },
    '._description': {
        gridArea: "description"
    },
    '._image': {
        gridArea: "image",
        width: 350,
    },
}));